import { Store, select } from '@ngrx/store';
import { createSelector, createFeatureSelector, ActionReducerMap } from '@ngrx/store';
import * as fromCompanySiteUserLocationReducer from './company-site-user-location.reducer';
import { TableArea } from '../../../../models/table-area.model';

export const selectTableState = createFeatureSelector<any>('addCompanySiteUserLocationReducer');
export const selectUserState = createFeatureSelector<fromCompanySiteUserLocationReducer.StateUser>('addSiteUserReducer');

export interface FeatureState {
  companyId: string;
  siteId: string;
}

export const selectCompanyId = createSelector(selectTableState,
  fromCompanySiteUserLocationReducer.getcompanyId
);

// export const selectCompanyId = createSelector(
//   selectTableState,
//   (state: FeatureState) => state.companyId
// );


export const selectSiteId = createSelector(selectTableState,
  fromCompanySiteUserLocationReducer.getSiteId
);

// export const selectSiteId = createSelector(
//   selectTableState,
//   (state: FeatureState) => state.siteId
// );

export const selectCompanyIdSiteId = createSelector(selectTableState,
  fromCompanySiteUserLocationReducer.getCompanyIdSiteId
);

// export const selectCompanyIdSiteId = createSelector(
//   selectTableState,
//   (state: FeatureState) => state
// );

export const selectCompanySiteCategoryProductGroupProductState = createFeatureSelector<fromCompanySiteUserLocationReducer.StateCompanySiteCategoryProductGroupProduct>('addCompanySiteCategoryProductGroupProductReducer');

export interface CompanySiteCategoryProductGroupProductState {
  companyId: string;
  siteId: string;
  categoryId: string;
  productGroupId: string;
  productId: string;
}

// export const selectCompanyIdSiteIdCategoryIdProductGroupIdProductId = createSelector(
//   selectCompanySiteCategoryProductGroupProductState,
//   (state: CompanySiteCategoryProductGroupProductState) => state
// );


export interface SiteUserState {
  userId: string;
}

export const selectUser = createSelector(selectUserState,
  fromCompanySiteUserLocationReducer.getUserId
);

// export const selectUser = createSelector(
//   selectUserState,
//   (state: SiteUserState) => state
// );

export const selectRoomNumberState = createFeatureSelector<fromCompanySiteUserLocationReducer.StateRoomNumber>('addSiteUserHotelRoomNumberReducer');
export interface RoomNumberState {
  roomNumber: string;
}
// export const selectRoomNumber = createSelector(
//   selectRoomNumberState,
//   (state: RoomNumberState) => state
// );
